import { BankruptcyCodes } from "../types";
export var ownershipTypes = [
    "D",
    "E",
    "G",
    "M",
    "F",
    "C",
    "EE",
    "I",
    "K",
    "L",
    "N",
    "NO",
    "O",
    "R",
];
export var cdProductCodes = [
    "3501",
    "3502",
    "3503",
    "3504",
    "3505",
    "3506",
    "3507",
    "3508",
    "3509",
    "3512",
    "3520",
];
export var inactiveAccountStatus = [
    "Inactive",
    "Dormant",
    "Escheat",
    "Closing",
    "Closed",
];
export var blockedLiveChatAlertCodesForDropdown = [
    "RPVRQ",
    "RPVIP",
    "ARCRR",
    "ARCRP",
    "LGCPG",
    "SLCPG",
    "DFL",
    "MIG",
    "FIF",
    "IFS",
    "IFC",
    "ODF",
    "DSIP",
    "DSCP",
];
export var blockedProductSubTypes = ["SNGLPAYLSE", "SPLSERP"];
export var blockedBankruptcyCodes = Object.values(BankruptcyCodes);
//# sourceMappingURL=constants.js.map